/**
 * Top-level layout. Renders the brand header and the active route
 * via Outlet. Initializes the auth hub listener.
 */

import { Outlet } from "react-router-dom";

import { BrandHeader } from "@/components/BrandHeader";
import { useAuthInit } from "@/lib/auth/useAuth";
import { useTenantBranding } from "@/lib/tenant/resolver";
import { TenantNotFound } from "./tenant-not-found";

export function RootLayout() {
  useAuthInit();
  const { data: branding, isLoading, isError, subdomain } = useTenantBranding();

  // No subdomain means we're on a host that doesn't match any tenant
  // (e.g., raw apex domain or a CloudFront default URL).
  if (subdomain && !isLoading && (isError || !branding)) {
    return <TenantNotFound />;
  }

  return (
    <div className="min-h-screen bg-starz-off-white">
      <BrandHeader branding={branding} />
      <main>
        <Outlet />
      </main>
    </div>
  );
}
